import { api, extractApiErrorMessage } from "./apiClient";
import { getCheckoutPlanForRole } from "../constants/plans";

export const startSubscriptionCheckout = async (user) => {
  if (!user?.role || user.role === "basic") {
    throw new Error("Tu cuenta gratuita ya está activa");
  }

  if (user.role === "admin") {
    throw new Error(
      "Tu cuenta administradora no puede activar suscripciones desde esta vista.",
    );
  }

  const planId = getCheckoutPlanForRole(user.role);
  if (planId === "free") {
    throw new Error("Tu cuenta gratuita ya está activa");
  }

  const response = await api.post("/subscription/checkout", {
    plan_id: planId,
    origin_url: window.location.origin,
  });

  const data = await response.json().catch(() => null);
  if (!response.ok) {
    throw new Error(
      extractApiErrorMessage(data, "No se pudo iniciar la activación"),
    );
  }

  if (!data?.checkout_url) {
    throw new Error("No se pudo crear la sesión de pago");
  }

  window.location.href = data.checkout_url;
  return data;
};